import app from '../../main'
const qs = require('qs')

export default {
    namespaced: true,
    state: {
        products: [],
        mobileProducts: [],
        product: {},
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 10
        },
        errors: {
            getProducts: '',
            getProduct: '',
            createProduct: '',
            updateProduct: '',
            updateProductsMass: '',
            deleteProductsMass: ''
        }
    },
    getters: {
        getFormattedProduct(state, getters, rootState, rootGetters) {
            if (!Object.keys(state.product).length) return {}
            let product = {
                id: state.product.ItemID,
                category: state.product.CategoryID,
                type: state.product.TypeID,
                material: state.product.materials[0].MaterialID,
                collection: state.product.CollectionID,
                fineness: rootGetters['finenesses/getFinenessIdByName'](
                    state.product.materials[0].pivot.Fineness,
                    state.product.materials[0].MaterialID
                ),
                color: state.product.materials[0].pivot.ColorID,
                technology: state.product.TechnologyID,
                decor: state.product.decor.map(decor => decor.DecorID),
                purpose: state.product.purposes.length
                    ? state.product.purposes[0].PurposeID
                    : '',
                gender: state.product.Gender,
                priceUnit: state.product.PriceUnit || 1,
                brand: state.product.brand.BrandID,
                article: state.product.Article,
                name: state.product.Name,
                size: state.product.Size,
                price: state.product.Price,
                weight: state.product.Weight,
                iteminsert: state.product.ItemInsert,
                supplierurl: state.product.SupplierURL
                    ? decodeURI(state.product.SupplierURL)
                    : '',
                descr: state.product.Description,
                inserts: state.product.inserts.map(item => {
                    return {
                        id: item.ItemInsertID,
                        material: item.MaterialID,
                        color: item.ColorID,
                        facet: item.FacetID,
                        clarity: item.Clarity,
                        size: item.Size,
                        quantity: item.Quantity,
                        faceNumber: item.FaceNumber
                    }
                }),
                images: state.product.images,
                visibility: state.product.access
                    ? state.product.access.AccessLevel
                    : 0,
                garniture: state.product.sets.length
                    ? { ...state.product.sets[0] }
                    : undefined,
                garnitureSavedId: state.product.sets.length
                    ? state.product.sets[0].set_id
                    : '' //если нужно удалить гарнитуру
            }

            if (state.product.item_watch) {
                product = {
                    ...product,
                    itemWatch: {
                        CaseShapeID: state.product.item_watch.CaseShapeID,
                        CaseSize: state.product.item_watch.CaseSize,
                        CaseHeight: state.product.item_watch.CaseHeight,
                        Mechanism: state.product.item_watch.Mechanism,
                        MechanismType: state.product.item_watch.MechanismType,
                        MechanismFeatures:
                            state.product.item_watch.MechanismFeatures,
                        MechanismInfo: state.product.item_watch.MechanismInfo,
                        Features: state.product.item_watch.Features,
                        BraceletWidth: state.product.item_watch.BraceletWidth,
                        BraceletMaterial:
                            state.product.item_watch.BraceletMaterial,
                        GlassType: state.product.item_watch.GlassType,
                        Battery: state.product.item_watch.Battery,
                        DialType: state.product.item_watch.DialType,
                        DialColor: state.product.item_watch.DialColor,
                        WaterResistance:
                            state.product.item_watch.WaterResistance,
                        PreciousMetalWeight:
                            state.product.item_watch.PreciousMetalWeight
                    }
                }
            }
            return product
        },
        getProductKeyValue: state => (productId, keyName) => {
            if (!productId || !keyName) return ''
            return state.products.find(item => item.ItemID == productId)[
                keyName
            ]
        }
    },
    mutations: {
        SET_PRODUCTS(state, payload) {
            state.products = payload
        },
        CLEAR_PRODUCTS(state) {
            state.products = []
            state.mobileProducts = []
            state.product = {}
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 10
            }
        },
        SET_MOBILE_PRODUCTS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileProducts = payload
            } else {
                state.mobileProducts = [...state.mobileProducts, ...payload]
            }
        },
        SET_PRODUCT(state, payload) {
            state.product = payload
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async clearProducts({ commit, state }) {
            commit('CLEAR_PRODUCTS')
        },
        async getProducts({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getProducts',
                val: ''
            })

            const url = '/supplier/items'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                app.$Progress.finish()

                commit('SET_PRODUCTS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalProducts',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_PRODUCTS', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getProducts',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getProducts',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async getProduct({ commit }, productId) {
            commit('SET_ERRORS', {
                key: 'getProduct',
                val: ''
            })

            commit('SET_PRODUCT', {})

            const url = `/supplier/items/${productId}`

            try {
                const resp = await this.$axios.get(url).then(res => {
                    return res.data
                })

                commit('SET_PRODUCT', resp)
                return resp
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getProduct',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getProduct',
                        val: 'Ошибка'
                    })
                }
            }
        },
        async createProduct({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'createProduct',
                val: ''
            })

            const url = '/supplier/items'

            try {
                const resp = await this.$axios.post(url, data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'createProduct',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async updateProduct({ commit }, payload) {
            commit('SET_ERRORS', {
                key: 'updateProduct',
                val: ''
            })

            const url = '/supplier/items/' + payload.id + '/' + payload.type

            try {
                const resp = await this.$axios.patch(url, payload.data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updateProduct',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async updateProductsMass({ commit }, payload) {
            commit('SET_ERRORS', {
                key: 'updateProductsMass',
                val: ''
            })

            const url = '/supplier/items/mass-update/' + payload.type

            try {
                const resp = await this.$axios.patch(url, payload.data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updateProductsMass',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async deleteProductsMass({ commit }, payload) {
            commit('SET_ERRORS', {
                key: 'deleteProductsMass',
                val: ''
            })

            const url = '/supplier/items/mass-delete'

            try {
                const resp = await this.$axios.delete(url, {
                    data: payload.data
                })
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'deleteProductsMass',
                        val: e.response.data
                    })
                }

                throw e
            }
        }
    }
}
